import { connect } from 'react-redux';
import { getIsLoggedIn } from '../../../publicSession';
var mapStateToProps = function (state, ownProps) {
    var _a = ownProps.showActions, showActions = _a === void 0 ? getIsLoggedIn(state) : _a, _b = ownProps.showAvatar, showAvatar = _b === void 0 ? true : _b;
    return {
        showActions: showActions,
        showAvatar: showAvatar,
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=CommentContent.container.js.map